module.exports = __webpack_public_path__ + "img/newyorktimes.08698be0.png";